import pokedexPic from './pokedex_pic.png';
import mapsnapPic from './mapsnap-pic.png';
import sticknotePic from './sticknote-pic.png';
import homepic from './home-pic.png';
import unitygamepic from './unity-game-pic.png';
export const projectsData = [
    {
        projectName: 'MapSnap',
        projectDescription: `Built an interactive web application that lets users pin locations on an interactive map, attach photos, and add short notes. Integrated Leaflet.js for mapping, Supabase for real-time storage and database handling, and designed a responsive, clean UI. Users can upload images, view them in popups directly on the map, and manage entries through a sidebar interface.`,
        imageUrl: mapsnapPic,
        projectUrl: 'https://dailynx.com/mapsnap/',
    },
    {
        projectName: 'PokeDex',
        projectDescription:
            "Developed a Pokedex web application that fetches real-time data from the PokeAPI. Showcases API integration, DOM manipulation, and clean UI implementation with HTML, CSS, and JavaScrip. So here I bring you a pokedex to check all Pokémon stats",
        imageUrl: pokedexPic,
        projectUrl: 'https://pokedex-lte5.vercel.app/',
        apiUrl: 'https://pokeapi.co/',
    },
    {
        projectName: 'Portfolio Website',
        projectDescription:
            'As a developer, we should definitely have our own portfolio. There are endless benefits of it. so here is one of me! made it using react.js, html & css.',
        imageUrl: homepic,
        projectUrl: '/',
    },
    {
        projectName: 'Sticky Note',
        projectDescription:
            'Created a sticky notes web application that allows users to add, edit, and delete notes directly in the browser. Notes are saved in localStorage. It\'s a simple responsive UI so users can quickly jot down thoughts and manage them in one place.',
        imageUrl: sticknotePic,
        projectUrl: 'https://sticky-note-gold.vercel.app/',
    },
    {
        projectName: 'Unity Game (C Sharp)',
        projectDescription:
            'Developed a 2D platformer game using Unity and C#. Implemented player movement. Focused on creating an engaging gameplay experience with smooth controls and obstacles.',
        imageUrl: unitygamepic,
        projectUrl: 'https://andrew-buestan-unity-game-c-sharp.vercel.app/',
    }
];